import * as yup from 'yup';
import _isEmpty from 'lodash/isEmpty';
import { Row, RenderConfig, TextInput, NumberInput, AsyncSelect, SelectInput, BOOLEAN_OPTIONS } from 'commons-ui';
import { IDepResolverProps } from 'models/settingsV2.model';

export const FORM_FIELD_KEYS = {
	USERNAME: 'name',
	EMAIL: 'email',
	PHONE_NO: 'phone',
	DEPARTMENT: 'department',
	MANAGER: 'manager',
	DESIGNATION: 'designation',
	TEAM: 'team',
	ROLE_NAME_TEMP: 'roleNameTemp',
	PERMISSION_SET: 'setId',
	PERMISSIONS: 'permissionIds',
	EXPIRE_AFTER_SEC: 'expiresAfter',
	IS_MASKED: 'isMasked'
};
export const validationSchema = yup.object().shape({
	email: yup.string().email('Please enter a valid email').required('Email ID is required'),
	phone: yup
		.string()
		.matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
		.max(10, 'Phone number cannot exceed 10 digits')
});

const permissionsDepResolver = (props: IDepResolverProps, dependencyValues: string[]) => {
	const permissionsSetValue = dependencyValues[0];
	const { disabled } = props;
	if (!_isEmpty(permissionsSetValue) && !disabled) {
		return { disabled: true };
	}
	if (_isEmpty(permissionsSetValue) && disabled) {
		return { disabled: false };
	}
	return null;
};

const permissionsSetDepResolver = (props: IDepResolverProps, dependencyValues: string[]) => {
	const permissionsValue = dependencyValues[0];
	const { disabled } = props;
	if (!_isEmpty(permissionsValue) && !disabled) {
		return { disabled: true };
	}
	if (_isEmpty(permissionsValue) && disabled) {
		return { disabled: false };
	}
	return null;
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.USERNAME),
	new Row(FORM_FIELD_KEYS.EMAIL),
	new Row(FORM_FIELD_KEYS.PHONE_NO),
	new Row(FORM_FIELD_KEYS.DEPARTMENT),
	new Row(FORM_FIELD_KEYS.MANAGER),
	new Row(FORM_FIELD_KEYS.DESIGNATION),
	new Row(FORM_FIELD_KEYS.TEAM),
	new Row(FORM_FIELD_KEYS.ROLE_NAME_TEMP),
	new Row(FORM_FIELD_KEYS.PERMISSIONS),
	new Row(FORM_FIELD_KEYS.PERMISSION_SET),
	new Row(FORM_FIELD_KEYS.EXPIRE_AFTER_SEC),
	new Row(FORM_FIELD_KEYS.IS_MASKED)
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.USERNAME]: new RenderConfig()
		.setName('name')
		.setLabel('Username')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),
	[FORM_FIELD_KEYS.EMAIL]: new RenderConfig()
		.setName('email')
		.setLabel('Email ID')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),
	[FORM_FIELD_KEYS.PHONE_NO]: new RenderConfig()
		.setName('phone')
		.setLabel('Phone No')
		.setRenderer(NumberInput)
		.setRenderProps({ isEditable: { create: true, edit: true } }),
	[FORM_FIELD_KEYS.DEPARTMENT]: new RenderConfig()
		.setName('department')
		.setLabel('Department')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.MANAGER]: new RenderConfig()
		.setName('manager')
		.setLabel('Manager')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.DESIGNATION]: new RenderConfig()
		.setName('designation')
		.setLabel('Designation')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.TEAM]: new RenderConfig()
		.setName('team')
		.setLabel('POD/Team')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.ROLE_NAME_TEMP]: new RenderConfig()
		.setName('roleNameTemp')
		.setLabel('Role Name (Temporary)')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: true } }),
	[FORM_FIELD_KEYS.PERMISSIONS]: new RenderConfig()
		.setName('permissionIds')
		.setLabel('Select Permissions')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			isHidden: { create: false, edit: true },
			required: true,
			multi: true,
			dependencies: ['setId'],
			dependencyResolver: permissionsDepResolver
		}),
	[FORM_FIELD_KEYS.PERMISSION_SET]: new RenderConfig()
		.setName('setId')
		.setLabel('Select Permission Set')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			isHidden: { create: false, edit: true },
			required: true,
			dependencies: ['permissionIds'],
			dependencyResolver: permissionsSetDepResolver
		}),
	[FORM_FIELD_KEYS.EXPIRE_AFTER_SEC]: new RenderConfig()
		.setName('expiresAfter')
		.setLabel('Expire After Sec')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			isHidden: { create: false, edit: true },
			placeholder:
				'Enter Time in milliseconds i.e. 1 sec = 1,000 milliseconds (Assign Permission will expire after this duration)'
		}),
	[FORM_FIELD_KEYS.IS_MASKED]: new RenderConfig()
		.setName('isMasked')
		.setLabel('Is Masked - Assigned permission will be masked for these users')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			isHidden: { create: false, edit: true },
			options: BOOLEAN_OPTIONS
		})
};
